<ngb-datepicker
  #dp
  [displayMonths]="displayMonths"
  [outsideDays]="outsideDays"
  [dayTemplate]="dayTemplate"
  [navigation]="navigation"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [weekdays]="1"
  (dateSelect)="dateSelect.emit($event)"
></ngb-datepicker>
